<template>
  <div class="sidebar background__lines" :class="{ hidden: !$store.getters['headerOpened'] }">
    <div class="sidebar__menu">
      <div v-for="(item, key) in navItems" :key="key" class="sidebar__menu_item">
        <div class="item">
          <RouterLink class="item__text" :title="item.name" :to="item.url">
            <div class="item-icon icon" :class="typeof item.icon === 'string' && item.icon ? item.icon : ''">
              <NIcon v-if="typeof item.icon !== 'string' && item.icon" size="24">
                <Component :is="item.icon" />
              </NIcon>
            </div>
            <div class="item__text_link">{{ item.name }}</div>
          </RouterLink>
        </div>
      </div>
    </div>
    <div class="sidebar__menu hide-menu" />

    <div class="sidebar__menu mt-auto mb-2">
      <div v-for="(item, key) in secondMenu" :key="key" class="sidebar__menu_item">
        <div class="item">
          <RouterLink class="item__text" :title="item.name" :to="item.url">
            <div class="item-icon icon">
              <NIcon size="24">
                <Component :is="item.icon" />
              </NIcon>
            </div>
            <div class="item__text_link">{{ item.name }}</div>
          </RouterLink>
        </div>
      </div>
    </div>
    <div class="sidebar__footer">
      <div class="sidebar__footer_button" @click="logout">
        <div class="icon exit-icon" />
        <div class="item__text">
          <div class="item__text_link">Выход</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { h } from 'vue'
import { NIcon } from 'naive-ui'
import {
  FileText,
  ChartAreaLine,
  BuildingSkyscraper,
  Video,
  CalendarEvent,
  SquareCheck,
  BrandTabler
} from '@vicons/tabler'
import ProcessIcon from '@/components/Icons/ProcessIcon'
import EventsIcon from '@/components/Icons/EventsIcon'

export default {
  name: 'SideBar',
  components: { NIcon },
  data() {
    return {
      navItems: [
        { name: 'Главная', icon: h(ChartAreaLine), url: '/statistic' },
        { name: 'Организация', icon: h(BuildingSkyscraper), url: '/organization/main' },
        { name: 'Процессы', icon: ProcessIcon, url: '/processes' },
        { name: 'Документация', icon: h(FileText), url: '/documents/organization' },
        { name: 'Мероприятия', icon: EventsIcon, url: '/actions' },
        { name: 'Аудит', icon: h(SquareCheck), url: '/audition' },
        { name: 'Календарь', icon: h(CalendarEvent), url: '/inspection' }
      ],
      secondMenu: [{ name: 'Обучение', icon: h(Video), url: '/videos' }]
    }
  },
  beforeMount() {
    let user = JSON.parse(localStorage.getItem('user'))
    if (user.id === 1) {
      this.navItems.push({ name: 'Админ панель', icon: h(BrandTabler), url: '/admin' })
    }
  },
  methods: {
    logout() {
      this.$store.dispatch('auth/logout')
      this.$router.push('/')
    }
  }
}
</script>

<style scoped>
.sidebar.hidden {
  width: 60px;
}

.item__text_link {
  color: white;
  transition: all 0.3s;
  white-space: nowrap;
}

.sidebar.hidden .item__text .item__text_link {
  display: none;
  white-space: nowrap;
}

.exit-icon {
  background-image: url("data:image/svg+xml,%3Csvg width='20' height='20' viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cg filter='url(%23filter0_d_550_6031)'%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M0.00879217 9.34389H0.0056092C0.0050708 9.35965 0.00436999 9.37445 0.00370274 9.38853C0.00215813 9.42114 0.000793407 9.44994 0.00203974 9.47825C-0.000679853 10.9147 -0.000679853 16.3524 0.00203974 17.7885C0.00560921 19.0248 0.988233 20.0036 2.22378 20.0036H4.36521C8.84047 20.0093 13.3157 20.008 17.7908 19.9998C18.7073 19.9998 19.3708 19.5473 19.7856 18.7355C19.9837 18.3502 20 17.9316 20 17.5068C19.9998 12.7939 19.9987 8.081 19.9967 3.36811C19.9966 3.26396 19.9974 3.15965 19.9981 3.05528C20.001 2.66215 20.0038 2.26817 19.9635 1.87913C19.8748 1.00792 19.1451 0.222379 18.2808 0.067617C17.9312 0.00502709 17.5677 0.00566755 17.2089 0.00629977C17.1731 0.0063629 17.1373 0.00642595 17.1016 0.00642595C12.5211 0.00370635 7.94029 0.00328143 3.35913 0.00515116C3.24402 0.0052113 3.12866 0.00389543 3.01323 0.0025788C2.63929 -0.00168645 2.26464 -0.00595983 1.89564 0.0365115C0.812819 0.160933 0 1.11347 0 2.20369V6.52556V6.66069H2.222V6.51689C2.22471 5.13177 2.22471 3.74647 2.222 2.361C2.22174 2.25596 2.25081 2.22307 2.35738 2.2246C2.64301 2.22907 2.92879 2.22837 3.21449 2.22767C3.31974 2.22741 3.42498 2.22715 3.53021 2.22715H17.6041C17.778 2.22715 17.778 2.22766 17.778 2.39823V7.05155V17.505C17.778 17.6451 17.7785 17.7143 17.7441 17.7485C17.71 17.7823 17.6419 17.7819 17.5054 17.7819H9.89432C7.39994 17.7831 4.90547 17.7831 2.41092 17.7819C2.31099 17.7818 2.2638 17.7907 2.24161 17.7711C2.2193 17.7515 2.22225 17.7032 2.22225 17.5881V11.1173H10.695L10.7141 11.1528L7.89578 13.9574L9.44773 15.5195L14.972 9.99806L9.44365 4.47277L7.86926 6.04819L10.7279 8.89433H0.00879217V9.34389Z' fill='white'/%3E%3C/g%3E%3Cdefs%3E%3Cfilter id='filter0_d_550_6031' x='0' y='0' width='21' height='21.0071' filterUnits='userSpaceOnUse' color-interpolation-filters='sRGB'%3E%3CfeFlood flood-opacity='0' result='BackgroundImageFix'/%3E%3CfeColorMatrix in='SourceAlpha' type='matrix' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0' result='hardAlpha'/%3E%3CfeOffset dx='1' dy='1'/%3E%3CfeComposite in2='hardAlpha' operator='out'/%3E%3CfeColorMatrix type='matrix' values='0 0 0 0 0.0117647 0 0 0 0 0.533333 0 0 0 0 0.52549 0 0 0 0.5 0'/%3E%3CfeBlend mode='multiply' in2='BackgroundImageFix' result='effect1_dropShadow_550_6031'/%3E%3CfeBlend mode='normal' in='SourceGraphic' in2='effect1_dropShadow_550_6031' result='shape'/%3E%3C/filter%3E%3C/defs%3E%3C/svg%3E%0A");
  width: 20px;
  height: 20px;
  margin-right: 10px;
}

.item__open_icon {
  background-image: url("data:image/svg+xml,%3Csvg width='10' height='5' viewBox='0 0 10 5' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M1.42322 4.79101C1.25673 4.92629 1.04874 5.00014 0.834217 5.00014C0.619693 5.00014 0.411707 4.92629 0.245217 4.79101C0.169198 4.73061 0.107796 4.65382 0.0655905 4.56638C0.023385 4.47894 0.00146484 4.3831 0.00146484 4.28601C0.00146484 4.18892 0.023385 4.09307 0.0655905 4.00563C0.107796 3.91819 0.169198 3.84141 0.245217 3.78101L4.41122 0.209009C4.57771 0.0737255 4.78569 -0.00012207 5.00022 -0.00012207C5.21474 -0.00012207 5.42273 0.0737255 5.58922 0.209009L9.75622 3.78101C9.83224 3.84141 9.89364 3.91819 9.93584 4.00563C9.97805 4.09307 9.99997 4.18892 9.99997 4.28601C9.99997 4.3831 9.97805 4.47894 9.93584 4.56638C9.89364 4.65382 9.83224 4.73061 9.75622 4.79101C9.58973 4.92629 9.38174 5.00014 9.16722 5.00014C8.95269 5.00014 8.74471 4.92629 8.57822 4.79101L5.00022 1.72401L1.42322 4.79101Z' fill='white'/%3E%3C/svg%3E%0A");
}

.item {
  height: 44px;
  display: flex;
  padding-top: 10px;
  padding-bottom: 10px;
  align-items: center;
}

.sidebar__footer {
  padding-left: 20px;
  padding-right: 20px;
}

.sidebar__menu {
  padding-left: 18px;
  padding-right: 18px;
}

.item__text {
  display: flex;
  font-size: 16px;
  color: white;
  align-items: center;
}

.item-icon {
  margin-right: 10px;
}

.sidebar__footer {
  padding-top: 20px;
  border-top: 1px solid rgba(255, 255, 255, 0.25);
  padding-bottom: 60px;
}

.sidebar__footer_button {
  display: flex;
  align-items: center;
  cursor: pointer;
  width: fit-content;
}

.sidebar {
  position: fixed;
  left: 0;
  padding-top: 20px;
  width: 232px;
  transition: width 0.3s;
  flex: none;
  display: flex;
  overflow-y: auto;
  overflow-x: hidden;
  top: 60px;
  height: calc(100% - 60px);
  flex-direction: column;
  justify-content: space-between;
  z-index: 100;
}

@media (min-width: 1920px) {
}
</style>
